import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Drives from '../views/Drives/Index.vue';
import Rules from '../views/Rules/Index.vue';
import RuleGroups from '../views/RuleGroups/Index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/drives',
    name: 'Drives',
    component: Drives,
  },
  {
    path: '/rules/:groupId',
    name: 'Rules',
    component: Rules,
    props: (route) => ({
      groupId: route.params.groupId,
      userRole: route.params.userRole,
    }),
  },
  {
    path: '/rule_groups',
    name: 'RuleGroups',
    component: RuleGroups,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
